import { actions } from './actions'

const initialState = {
  fonts: {
    data: [],
    loading: false,
    error: '',
  },
  font: {
    data: null,
    loading: false,
    error: '',
  },
}

export default function fontsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FONTS_LOAD_REQUESTED:
      return { ...state, fonts: { ...state.fonts, loading: true } }
    case actions.FONTS_LOAD_SUCCEEDED:
      return {
        ...state,
        fonts: { ...state.fonts, data: action.payload, loading: false },
      }
    case actions.FONTS_LOAD_FAILED:
      return {
        ...state,
        fonts: { ...state.fonts, loading: false, error: action.error },
      }

    case actions.FONTS_FILTERED_LOAD_REQUESTED:
      return {
        ...state,
        fonts: { ...state.fonts, data: null, loading: true },
      }
    case actions.FONTS_FILTERED_LOAD_SUCCEEDED:
      return {
        ...state,
        fonts: { ...state.fonts, data: action.payload, loading: false },
      }
    case actions.FONTS_FILTERED_LOAD_FAILED:
      return {
        ...state,
        fonts: { ...state.fonts, loading: false, error: action.error },
      }

    case actions.FONTS_GENERATE_REQUESTED:
      return {
        ...state,
        fonts: { data: state.fonts.data, loading: true },
      }
    case actions.FONTS_GENERATE_SUCCEEDED:
      return {
        ...state,
        fonts: { data: state.fonts.data, loading: false },
      }
    case actions.FONTS_GENERATE_FAILED:
      return {
        ...state,
        fonts: { ...state.fonts, loading: false, error: action.error },
      }

    case actions.FONTS_DELETED_REQUESTED:
      return {
        ...state,
        fonts: { ...state.fonts, loading: true, error: '' },
      }
    case actions.FONTS_DELETED_SUCCEEDED:
      return {
        ...state,
        fonts: {
          ...state.fonts,
          data: {
            ...state.fonts.data,
            fonts: state.fonts.data.fonts.filter(
              fuente => fuente.id !== Number(action.payload)
            )
          },
          loading: false,
          error: ''
        }
      }
    case actions.FONTS_DELETED_FAILED:
      return {
        ...state,
        fonts: { ...state.fonts, loading: false, error: action.error },
      }

    case actions.FONTS_INSERTERED_REQUESTED:
      return {
        ...state,
        fonts: { ...state.fonts, loading: true, error: '' },
      }
    case actions.FONTS_INSERTERED_SUCCEEDED:      
      return {
        ...state,
        fonts: {
          ...state.fonts,
          data: {
            urlFonts: action.payload.urlFonts,
            fonts: [          
              ...state.fonts.data.fonts.map(f => {
                const nueva = action.payload.fonts.find(p => p.id === f.id)
                return nueva ? nueva : f
              }),          
              ...action.payload.fonts.filter(
                p => !state.fonts.data.fonts.some(f => f.id === p.id)
              )
            ]
          },
          loading: false,
          error: ''
        }
      }
    case actions.FONTS_INSERTERED_FAILED:
      return {
        ...state,
        fonts: { ...state.fonts, loading: false, error: action.error },
      }

    case actions.FONTS_UPDATED_REQUESTED:
      return {
        ...state,
        fonts: { ...state.fonts, loading: true, error: '' },
      }
    case actions.FONTS_UPDATED_SUCCEEDED:
      return {
        ...state,
        fonts: {
          ...state.fonts,
          data: {
            urlFonts: action.payload.urlFonts,
            fonts: [          
              ...state.fonts.data.fonts.map(f => {
                const nueva = action.payload.fonts.find(p => p.id === f.id)
                return nueva ? nueva : f
              }),          
              ...action.payload.fonts.filter(
                p => !state.fonts.data.fonts.some(f => f.id === p.id)
              )
            ]
          },
          loading: false,
          error: ''
        }
      }
    case actions.FONTS_UPDATED_ORDER_REQUESTED:
      return {
        ...state,
        fonts: { data: state.fonts.data, loading: true, error: '' },
      }
    case actions.FONTS_UPDATED_ORDER_SUCCEEDED:
      return {
        ...state,
        fonts: { data: state.fonts.data, loading: false, error: '' },
      }
    case actions.FONTS_UPDATED_ORDER_FAILED:
      return {
        ...state,
        fonts: { ...state.fonts, loading: false, error: action.error },
      }
    case actions.RESET_FONT:      
      return {
        ...state,
        font: {
          data: null,
          loading: false,
          error: '',
        },
      }
    case actions.FONT_BYID_LOAD_REQUESTED:
      return {
        ...state,
        font: { ...state.fonts, loading: true, error: '' },
      }
    case actions.FONT_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        font: { ...state.fonts, data: action.payload, loading: false, error: '' },
      }
    case actions.FONT_BYID_LOAD_FAILED:
      return {
        ...state,
        font: { ...state.fonts, loading: false, error: action.error },
      }

    case actions.FONT_BYID_LOAD_INSERT_REQUESTED:
      return {
        ...state,
        font: { ...state.fonts, loading: true, error: '' },
      }
    case actions.FONT_BYID_LOAD_INSERT_SUCCEEDED:
      return {
        ...state,
        font: { ...state.fonts, data: action.payload, loading: false, error: '' },
      }
    case actions.FONT_BYID_LOAD_INSERT_FILED:
      return {
        ...state,
        font: { ...state.fonts, loading: false, error: action.error },
      }

    default:
      return state
  }
}
